<template>
  <div>
    <div class="row">
      <div class="col" align="right">
        <v-row justify="center">
          <v-dialog v-model="createPermiso" persistent max-width="600px">
            <!-- boton nuevo cuenta  -->
            <template v-slot:activator="{ on, attrs }">
              <div class="col-md-12" align="right">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="abrir_create()"
                >
                  Nuevo permiso
                </v-btn>
              </div>
            </template>
            <!-- end boton nuevo cuenta  -->
            <v-card>
              <v-card-title>
                <span class="text-h5">Nuevo permiso</span>
                <v-spacer></v-spacer>
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="cerrar_create()"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </v-card-title>
              <div v-if="procensando_datos">
                <loader
                  object="#4caf50"
                  color1="#ffffff"
                  color2="#17fd3d"
                  size="5"
                  speed="2"
                  bg="#343a40"
                  objectbg="#999793"
                  opacity="40"
                  disableScrolling="false"
                  name="box"
                ></loader>
              </div>
              <v-card-text>
                <v-container>
                  <v-form ref="form_create" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="permiso"
                      :counter="30"
                      :rules="namepermiso"
                      label="Permiso"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="scope"
                      :counter="30"
                      :rules="namescope"
                      label="Scope"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="descripcion"
                      :counter="30"
                      :rules="namedescripcion"
                      label="Descripcion"
                      required
                    ></v-text-field>

                    <!-- activar retiros_automaticos -->
                    <v-checkbox
                      v-model="activo"
                      class="ckeck"
                      label="Activo/Inactivo"
                    ></v-checkbox>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cerrar_create()">
                  Cerrar
                </v-btn>
                <v-btn
                  :disabled="!valid"
                  :loading="dialog"
                  color="blue darken-1"
                  text
                  @click="guardar_permiso()"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </div>
    <br />
    <!-- DATATABLE -->
    <v-app>
      <v-main>
        <v-container fluid>
          <div class="card">
            <div class="card-header card-header-success">
              <h4 class="card-title">Permisos</h4>
              <p class="card-category"></p>
            </div>
            <!-- SHOW ERROR SECTION -->
            <section v-if="errored">
              <v-alert
                border="left"
                class="mt-4 mx-3 elevation-3"
                color="red lighten-2"
                dark
              >
                Lo sentimos, no es posible obtener la información en este
                momento, por favor intente nuevamente mas tarde.
              </v-alert>
            </section>
            <!-- END SHOW ERROR SECTION -->
            <section v-else>
              <!-- DATOS DE LA TABLA -->
              <!-- FILTRO BUSCAR -->
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchPermiso"
                  append-icon="mdi-magnify"
                  label="Buscar Permiso"
                  single-line
                  hide-details
                  clearable
                >
                </v-text-field>
              </v-card-title>

              <!-- END FILTRO BUSCAR -->
              <v-data-table
                :headers="headers"
                :items="desserts"
                :loading="cargando"
                :items-per-page="rowsPerPage"
                hide-default-footer
                loading-text="Cargando... Espere por favor"
                no-results-text="No se encontraron registros"
                no-data-text="No se encontraron registros"
                class="elevation-1 trow"
              >
                <template v-slot:[`item.Activo`]="{ item }">
                  <v-chip :color="getColor(item.Activo)" dark>
                    {{ retiros_automaticos(item.Activo) }}
                  </v-chip>
                </template>

                <!-- ACCIONES BOTONES -->
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-spacer></v-spacer>
                    <!-- modal editar cliente  -->
                    <v-dialog v-model="dialog" max-width="500px">
                      <v-card>
                        <v-card-title>
                          <span class="text-h5"
                            >Editar permiso {{ editpermiso }}</span
                          >
                          <v-spacer></v-spacer>
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="close"
                                icon
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>close</v-icon>
                              </v-btn>
                            </template>
                          </v-menu>
                        </v-card-title>
                        <div v-if="procensando_datos">
                          <loader
                            object="#4caf50"
                            color1="#ffffff"
                            color2="#17fd3d"
                            size="5"
                            speed="2"
                            bg="#343a40"
                            objectbg="#999793"
                            opacity="40"
                            disableScrolling="false"
                            name="box"
                          ></loader>
                        </div>
                        <v-form
                          ref="form_create"
                          v-model="valid"
                          lazy-validation
                        >
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    v-model="editpermiso"
                                    :counter="30"
                                    :rules="namepermiso"
                                    label="Permiso"
                                    required
                                  >
                                  </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    v-model="editscope"
                                    :counter="30"
                                    :rules="namescope"
                                    label="Scope"
                                    required
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    v-model="editdescripcion"
                                    :counter="30"
                                    :rules="namedescripcion"
                                    label="Descripción"
                                    required
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                  <v-checkbox
                                    v-model="editactivo"
                                    class="ckeck"
                                    label="Activo/Inactivo"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">
                              Cancelar
                            </v-btn>
                            <v-btn
                              :disabled="!valid"
                              color="blue darken-1"
                              text
                              @click="actualizar"
                            >
                              Actualizar
                            </v-btn>
                          </v-card-actions>
                        </v-form>
                      </v-card>
                    </v-dialog>

                    <!-- modal eliminar -->
                    <v-dialog v-model="dialogDelete" max-width="400px">
                      <v-card>
                        <v-card-title class="text-h5 justify-center"
                          >¿Eliminar {{ editpermiso }}?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >Confirmar</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <!-- BOTONES DE LA TABLA -->
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon class="mr-2" color="orange" @click="editItem(item)">
                    create
                  </v-icon>

                  <v-icon color="red" @click="deleteItem(item)">
                    delete
                  </v-icon>
                </template>
                <!--END  BOTONES DE LA TABLA -->
                <!--  Paginacion  -->
                <template v-slot:footer>
                  <v-row class="no-gutters mt-2 mx-2">
                    <v-flex xs12>
                      <span>Mostrar</span>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            dark
                            text
                            color="primary"
                            class="ml-2"
                            v-on="on"
                          >
                            {{ rowsPerPage }}
                            <v-icon>arrow_drop_down</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(number, index) in rowsPerPageArray"
                            :key="index"
                            @click="updateRowsPerPage(number)"
                          >
                            <v-list-item-title>{{ number }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-row>
                </template>
              </v-data-table>
              <div class="text-center pt-2">
                <v-pagination
                  v-model="pagination.page"
                  :length="pagination.total"
                  :total-visible="pagination.visible"
                  @input="onPageChange"
                ></v-pagination>
              </div>
            </section>
          </div>
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>
<script>
import { Permisos } from "../../services/permisos.js";
import { mapState } from "vuex";
export default {
  data: () => ({
    name: "Roles",
    // *1 array donde se renderizan los roles
    desserts: [],
    // efecto cargando en tabla
    cargando: false,
    //   modal de editar y eliminar
    dialog: false,
    dialogDelete: false,
    // mostrar error de api
    errored: false,
    // res indica el resultado de las validaciones
    res: false,
    //loaders para procesar datos dee envio POST, UPDATE, DELETE
    procensando_datos: false,
    // Filter models del datatable
    searchPermiso: "",
    headers: [
      { text: "Permiso", value: "Permiso" },
      { text: "Scope", value: "Scope" },
      { text: "Descripción", value: "Descripcion" },
      { text: "Activo", value: "Activo" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    // paginacion api
    pagination: {
      page: 1,
      total: 0,
      visible: 7,
    },
    //  numero de registros por pagina
    rowsPerPageArray: [10, 20, 30],
    rowsPerPage: 10,

    // nuevo rol POST
    createPermiso: false,
    permiso: "",
    scope: "",
    descripcion: "",
    activo: false,

    // campos a actualizar rol PUT
    editID: "",
    editSistemasId: "",
    editpermiso: "",
    editscope: "",
    editdescripcion: "",
    editactivo: false,

    // validaciones cuenta
    valid: false,
    namepermiso: [
      (v) => !!v || "Permiso es requerido",
      (v) =>
        (v && v.length <= 30) ||
        "El campo Permiso no debe superar los 30 caracteres",
    ],
    namescope: [
      (v) => !!v || "Scope es requerido",
      (v) =>
        (v && v.length <= 30) ||
        "El campo Scope no debe superar los 30 caracteres",
    ],
    namedescripcion: [
      (v) => !!v || "Descripción es requerido",
      (v) =>
        (v && v.length <= 30) ||
        "El campo Descripción no debe superar los 22 caracteres",
    ],
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    searchPermiso() {
      this.getPermisos();
    },
  },
  created() {
    this.getPermisos();
  },
  //listar todos los permisos
  computed: {
    ...mapState(["SISTEMA_ID"]),
  },
  methods: {
    getPermisos: function() {
      const params = {
        SistemaId: this.SISTEMA_ID,
        Number: this.pagination.page,
        Size: this.rowsPerPage,
      };

      if (this.searchPermiso) {
        params.BusquedaScopeDescripcionPermisos = this.searchPermiso;
      }

      this.cargando = true;
      Permisos.getPermisos(params)
        .then((response) => {
          if (response.data.data == null) {
            this.desserts = [];
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.cargando = false;
          } else {
            this.desserts = response.data.data;
            this.pagination.page = response.data.meta.page.currentPage;
            this.pagination.total = response.data.meta.page.lastPage;
          }
        })
        .catch((error) => {
          this.errored = true;
          var data = error.response.data;
          this.error = true;
          this.$toastr.e(data.message);
        })
        .finally(() => (this.cargando = false));
    },

    // paginar
    onPageChange() {
      this.getPermisos();
    },
    // registros por paginas
    updateRowsPerPage(number) {
      this.rowsPerPage = number;
      this.pagination.page = 1;
      this.getPermisos();
    },

    // personalizar datos de la tabla
    getColor(value) {
      if (value == true) return "#43A047";
      else return "#EF5350";
    },

    retiros_automaticos(value) {
      if (value === true) {
        return "Activo";
      } else {
        return "Inactivo";
      }
    },

    abrir_create() {
      this.createPermiso = true;
      this.limpiar_campos();
    },

    cerrar_create() {
      this.createPermiso = false;
      this.$refs.form_create.reset();
      this.limpiar_campos();
    },

    // guardar nuevo permiso
    async guardar_permiso() {
      var payload = {
        SistemasId: parseInt(this.SISTEMA_ID),
        Permiso: this.permiso,
        Scope: this.scope,
        Descripcion: this.descripcion,
        Activo: this.activo,
      };
      this.validate();
      if (this.res === true) {
        this.error = false;
        this.procensando_datos = true;
        await Permisos.nuevo_permiso(payload)
          .then((response) => {
            this.$toastr.s("El permiso se creo correctamente");
            this.getPermisos();
            this.createPermiso = false;
            // limpiar validaciones y campos
            this.$refs.form_create.reset();
            this.limpiar_campos();
          })
          .catch((error) => {
            this.errored = true;
            var data = error.response.data;
            this.error = true;
            this.$toastr.e(data.message);
          })
          .finally(() => (this.procensando_datos = false));
      } else {
        this.$toastr.e("Error al enviar formulario, verificar datos de envio");
      }
    },

    //mostrar en modal los datos del permiso modificar
    editItem(item) {
      this.dialog = true;
      (this.editID = item.Id), (this.editSistemasId = item.SistemasId);
      this.editpermiso = item.Permiso;
      this.editscope = item.Scope;
      this.editdescripcion = item.Descripcion;
      this.editactivo = item.Activo;
    },

    //  consultar el id del permiso a eliminar
    deleteItem(item) {
      this.editID = item.Id;
      this.editpermiso = item.Permiso;
      this.dialogDelete = true;
    },

    // confirmar permiso a eliminar
    deleteItemConfirm() {
      var SistemaId = parseInt(this.SISTEMA_ID);
      this.error = false;
      this.loading = true;
      this.procensando_datos = true;
      Permisos.delete_permiso(SistemaId, this.editID)
        .then((response) => {
          this.$toastr.s("El permiso se elimino con éxito");
          this.getPermisos();
        })
        .catch((error) => {
          this.errored = true;
          var data = error.response.data;
          this.error = true;
          this.loading = false;
          this.$toastr.e(data.message);
          this.dialog = false;
          this.procensando_datos = false;
        })
        .finally(() => (this.cargando = false));
      // cerrrar modal
      this.closeDelete();
    },

    //confirmar actualizar rol
    async actualizar() {
      var payload = {
        id: this.editID,
        SistemasId: this.editSistemasId,
        Permiso: this.editpermiso,
        Scope: this.editscope,
        Descripcion: this.editdescripcion,
        Activo: this.editactivo,
      };
      this.validate();
      if (this.res === true) {
        this.error = false;
        this.procensando_datos = true;
        await Permisos.actualizar_permiso(payload)
          .then((response) => {
            this.dialog = false;
            this.$toastr.s("El permiso se actualizo correctamente");
            this.getPermisos();
            this.close();
          })
          .catch((error) => {
            this.errored = true;
            var data = error.response.data;
            this.error = true;
            this.$toastr.e(data.message);
          })
          .finally(() => (this.procensando_datos = false));
      } else {
        this.$toastr.e("Error al enviar formulario, verificar datos de envio");
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    validate() {
      this.$refs.form_create.validate();
      this.res = this.$refs.form_create.validate();
    },
    limpiar_campos() {
      this.permiso = "";
      this.scope = "";
      this.descripcion = "";
      this.activo = false;
    },
  },
};
</script>
<style scoped>
.trow {
  transition: transform 0.3s;
}

.trow:hover {
  cursor: pointer;
  transform: scale(1.03);
  background: rgb(228, 228, 228);
  color: rgb(19, 18, 18);
}

a[data-v-1b84c964] {
  color: #3aad1e;
}

.theme--light.v-btn {
  color: rgb(93 175 118 / 87%);
}

.theme--dark.v-btn.v-btn--has-bg {
  background-color: #50b565;
}
</style>
